import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { IncludesList } from '@/components/booking/homeSteps';

const COPY = {
  home: { title: 'Order submitted', text: "We'll confirm your shoot date and time shortly. You'll get an invoice after the shoot." },
  'land-quote': { title: 'Quote request sent', text: "We'll review the parcel and reply with a custom price within 24 hours. No payment has been taken." },
  quote: { title: 'Quote request sent', text: "We'll review your project and reply with a price within 24 hours. No payment has been taken." },
};

export const BookDone = ({ kind, orderNumber, pkg }) => (
  <div className="min-h-[calc(100dvh-72px)] bg-[#050816] flex items-center justify-center px-6 py-16 text-center" data-testid="book-done">
    <div className="max-w-md">
      <CheckCircle2 className="h-14 w-14 text-[#C6A14A] mx-auto mb-4" />
      <h1 className="font-serif text-3xl text-white" data-testid="book-done-title">{COPY[kind].title}</h1>
      <p className="text-[#E8E4DE]/70 mt-3">{COPY[kind].text}</p>
      {orderNumber && <p className="text-white font-mono text-lg mt-4" data-testid="order-number">{orderNumber}</p>}
      {pkg && (
        <div className="mt-5 rounded-xl border border-white/10 bg-[#0f1724] px-5 py-4 text-left" data-testid="book-done-package">
          <p className="text-white font-medium">{pkg.name} — ${pkg.price}</p>
          <IncludesList pkg={pkg} testId="book-done-includes" />
        </div>
      )}
      <div className="flex flex-col gap-3 mt-6">
        <Button asChild className="h-12 bg-[#C6A14A] text-[#050816] hover:bg-[#D4AF5A]" data-testid="book-done-orders-btn"><Link to="/orders">View my orders</Link></Button>
        <Button asChild variant="outline" className="h-12 border-white/15 text-[#E8E4DE] bg-transparent hover:bg-white/5" data-testid="book-done-home-btn"><Link to="/">Return home</Link></Button>
      </div>
    </div>
  </div>
);
